
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b12",
      function () {
        return require("private-next-pages/b12.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b12"])
      });
    }
  